import { ClerkProvider } from '@/components/auth/ClerkProvider'
import { UserLoader } from '@/components/auth/UserLoader'
import { WorkosProvider } from '@/components/auth/WorkosProvider'
import { AppLoader } from '@/components/loading/AppLoader'
import { OrganizationsLoader } from '@/components/organization/OrganizationsLoader'
import { ReactQueryProvider } from '@/components/react-query/react-query-provider'
import { Toaster } from '@/components/ui/sonner'
import { routeTree } from '@/routeTree.gen'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { ThemeProvider } from 'next-themes'
import { StrictMode } from 'react'

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

export type AppRouter = typeof router

export function App() {
  return (
    <StrictMode>
      <ReactQueryProvider>
        <ThemeProvider>
          <ClerkProvider>
            <WorkosProvider router={router}>
              <UserLoader />
              <OrganizationsLoader />
              <AppLoader>
                <RouterProvider router={router} />
                <Toaster />
              </AppLoader>
            </WorkosProvider>
          </ClerkProvider>
        </ThemeProvider>
      </ReactQueryProvider>
    </StrictMode>
  )
}
